import React, { memo } from 'react'
import PropTypes from 'prop-types'
import IndeterminateCheckbox from '../../../IndeterminateCheckBox/IndeterminateCheckBox'
import { Center } from '@chakra-ui/react'

const HeaderCheckbox = ({
  getToggleAllRowsSelectedProps,
  validateSelectable,
}) => {
  return (
    <Center>
      {!validateSelectable && (
        <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
      )}
    </Center>
  )
}
HeaderCheckbox.propTypes = {
  getToggleAllRowsSelectedProps: PropTypes.func,
  validateSelectable: PropTypes.func,
}
export default memo(HeaderCheckbox)
